import { Button } from "@progress/kendo-react-buttons";
import { SvgIcon } from "@progress/kendo-react-common";
import { DropDownList } from "@progress/kendo-react-dropdowns"
import { CheckboxChangeEvent, TextArea, TextBox, TextBoxChangeEvent, TextBoxProps } from "@progress/kendo-react-inputs"
import { useLocalization } from "@progress/kendo-react-intl";
import { Avatar } from "@progress/kendo-react-layout";
import { cancelIcon, copyIcon, plusIcon, rssIcon, saveIcon, trashIcon, xIcon } from "@progress/kendo-svg-icons";
import { cloneElement, useCallback, useEffect, useRef, useState } from "react";
import { AccessToken } from "../../../config/AccessToken";
import { Window } from "@progress/kendo-react-dialogs";
import { FirstSequence } from "./backchannelSequences/FirstSequence";
import { SecondSequence } from "./backchannelSequences/SecondSequence";
import { FourthSequence } from "./backchannelSequences/FourthSequence";
import { ThirdSequence } from "./backchannelSequences/ThirdSequence";
import axios from "axios";
import { InteractionRequiredAuthError } from "@azure/msal-browser";
import { NotificationGroup, Notification } from "@progress/kendo-react-notification";
import { Fade } from "@progress/kendo-react-animation";
import { ListBox } from "@progress/kendo-react-listbox";
import { loadingPanel } from "../../LoadingPanel";


export const ConfigRulesSubscriptionAPI = () => {


    const localizationService = useLocalization();
    let languageId = localStorage.getItem('languageId');
    const SERVER_URL = process.env.REACT_APP_SERVER_URL;
    const [instance, accessTokenRequest] = AccessToken();

    const typeData = {
        "data": [
            {
                "id": 0,
                "name": 'GET',
                "color": 'blue'
            },
            {
                "id": 1,
                "name": 'POST',
                "color": 'green'
            },
            {
                "id": 2,
                "name": 'PUT',
                "color": 'orange'
            },
            {
                "id": 3,
                "name": 'DELETE',
                "color": 'brown'
            },
            {
                "id": 4,
                "name": 'PATCH',
                "color": 'purple'
            }
        ]
    }

    const metadataList = {
        "data": [
            { "id": 0, "name": "{device.mac}" },
            { "id": 1, "name": "{device.name}" },
            { "id": 2, "name": "{device.serialnumber}" },
            { "id": 3, "name": "{device.type}" },
            { "id": 4, "name": "{device.version}" },
            { "id": 5, "name": "{device.group.id}" },
            { "id": 6, "name": "{device.job.id}" },
            { "id": 7, "name": "{device.ip}" },
            { "id": 8, "name": "{datetime}" },
            { "id": 9, "name": "{datetime.unix}" },
            { "id": 10, "name": "{zone.id}" },
            { "id": 11, "name": "{zone.name}" },
            { "id": 12, "name": "{account.id}" },
            { "id": 13, "name": "{account.name}" },
            { "id": 14, "name": "{event.type.id}" },
            { "id": 15, "name": "{event.type.name}" },
            { "id": 16, "name": "{event.wakeup.id}" },
            { "id": 17, "name": "{event.wakeup.position}" },
            { "id": 18, "name": "{event.wakeup.position.x}" },
            { "id": 19, "name": "{event.wakeup.position.y}" },
            { "id": 20, "name": "{event.wakeup.position.elevation}" },
            { "id": 21, "name": "{event.wakeup.position.orientation}" },
            { "id": 22, "name": "{alarm.param1}" },
            { "id": 23, "name": "{alarm.param2}" },
            { "id": 24, "name": "{alarm.param3}" },
            { "id": 25, "name": "{alarm.param4}" }
        ]
    }

    const deviceType = {
        "data": [
            {
                "id": 0,
                "name": 'Persona'
            },
            {
                "id": 1,
                "name": 'Veicolo'
            }
        ]
    }

    const commandType = {
        "data": [
            {
                "id": 0,
                "name": 'Configura'
            },
            {
                "id": 1,
                "name": 'Rilascia'
            }
        ]
    }

    var firstRele: any, secondRele: any = []

    firstRele = secondRele = {
        "data": [
            {
                "id": 0,
                "name": 'Open'
            },
            {
                "id": 1,
                "name": 'Closed'
            },
            {
                "id": 2,
                "name": 'Unchanged Released'
            }
        ]
    }

    var redValues: any, greenValues: any, blueValues: any, buzzzerValue: any, vibrationValue: any = [];

    redValues = greenValues = blueValues = buzzzerValue = vibrationValue = {
        "data": [
            {
                "id": 0,
                "name": 'ON'
            },
            {
                "id": 1,
                "name": 'OFF'
            },
            {
                "id": 2,
                "name": 'LF'
            },
            {
                "id": 3,
                "name": 'HF'
            }
        ]
    }

    const durationValue = {
        "data": [
            {
                "id": 0,
                "name": '1s'
            },
            {
                "id": 1,
                "name": '0'
            },
            {
                "id": 2,
                "name": '500ms'
            },
            {
                "id": 3,
                "name": '2s'
            }
        ]
    }

    const [error, setError] = useState('');

    const [apiName, setApiName] = useState<any>([]);
    const [newSubscriptionAPI, setNewSubscriptionAPI] = useState<any>([]);

    const [subscriptionName, setSubscriptionName] = useState<any>('');
    const [subscriptionIdSelected, setSubscriptionIdSelected] = useState<any>(-1);

    //const [typeList, setTypeList] = useState<any>(typeData);
    const [typeName, setTypeName] = useState<any>([]);
    const [typeColor, setTypeColor] = useState<any>([]);
    const [typeSelected, setTypeSelected] = useState<boolean>(false);

    const [metadataHeaderSelected, setMetadataHeaderSelected] = useState<any>([]);
    const [metadataParamSelected, setMetadataParamSelected] = useState<any>([]);
    const [metadataUrlSelected, setMetadataUrlSelected] = useState<any>([]);
    const [metadataBodySelected, setMetadataBodySelected] = useState<any>([]);

    const [focusHeader, setFocusHeader] = useState<any>(false);
    const [keyHeader, setKeyHeader] = useState<TextBoxProps["value"]>('');
    const [headerValue, setHeaderValue] = useState<any>('');
    const [newHeaderAPI, setNewHeaderAPI] = useState<any>([]);
    const [newHeaderKey, setNewHeaderKey] = useState<any>([]);
    const [keyValueHeaderList, setKeyValueHeaderList] = useState<any>([]);

    const [focusUrl, setFocusUrl] = useState<any>(false);
    const [url, setUrl] = useState<any>('');

    const [focusBody, setFocusBody] = useState<any>(false);
    const [body, setBody] = useState<any>('');

    const [showAPIBackchannel, setShowAPIBackchannel] = useState<boolean>(false);
    const [deviceTypeList, setDeviceTypeList] = useState<any>(deviceType);
    const [deviceTypeName, setDeviceTypeName] = useState<any>([]);
    const [insertTime, setInsertTime] = useState<any>([]);
    const [commandTypeList, setCommandTypeList] = useState<any>(commandType);
    const [commandTypeName, setCommandTypeName] = useState<any>([]);


    const [duration, setDuration] = useState<any>('');
    const [unitDuration, setUnitDuration] = useState<any>('');
    const [unitDurationConverted, setUnitDurationConverted] = useState<any>('');

    const [checkedFirstSequence, setCheckedFirstSequence] = useState<boolean | null | undefined>(false);
    const [checkedSecondSequence, setCheckedSecondSequence] = useState<boolean | null | undefined>(false);
    const [checkedThirdSequence, setCheckedThirdSequence] = useState<boolean | null | undefined>(false);
    const [checkedFourthSequence, setCheckedFourthSequence] = useState<boolean | null | undefined>(false);

    const [firstRedValue, setFirstRedValue] = useState<any>([]);
    const [firstGreenValue, setFirstGreenValue] = useState<any>([]);
    const [firstBlueValue, setFirstBlueValue] = useState<any>([]);
    const [firstBuzzValue, setFirstBuzzValue] = useState<any>([]);
    const [firstVibrationValue, setFirstVibrationValue] = useState<any>([]);
    const [durationValueSelected, setDurationValueSelected] = useState<any>([]);

    const [firstReleList, setFirstReleList] = useState<any>(firstRele);
    const [secondReleList, setSecondReleList] = useState<any>(secondRele);
    const [firstReleValue, setFirstReleValue] = useState<any>([]);
    const [secondReleValue, setSecondReleValue] = useState<any>([]);

    const [focusParam, setFocusParam] = useState<any>(false);
    const [keyParam, setKeyParam] = useState<TextBoxProps["value"]>('');
    const [paramValue, setParamValue] = useState<any>('');
    const [newParamAPI, setNewParamAPI] = useState<any>([]);
    const [newParamKey, setNewParamKey] = useState<any>([]);
    const [keyValueParamList, setKeyValueParamList] = useState<any>([]);

    const [nameMessage, setNameMessage] = useState(false);

    const [loading, setLoading] = useState(false);
    const [saved, setSaved] = useState(false);
    const [removed, setRemoved] = useState(false);
    const [updated, setUpdated] = useState(false);
    const [headerMessage, setHeaderMessage] = useState(false);
    const [paramMessage, setParamMessage] = useState(false);

    const formatDate = (dateString:any) => {
        const date = new Date(dateString);
      
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Month is 0-indexed
        const year = date.getFullYear();
      
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        const seconds = String(date.getSeconds()).padStart(2, '0');
      
        return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
    }

    useEffect(() => {
        getSubscriptionAPIList()
    }, [])

    const getSubscriptionAPIList = async () => {
        setLoading(true);

        const commonOperations = async (accessToken: any) => {
            const headers = { 'Authorization': `Bearer ${accessToken}`, 'Language': languageId };
            axios.get(`${SERVER_URL}/subscription/api/list`, { headers })
                .then((res) => {
                    const data = res.data.data
                    if (data.length > 0) {
                        data.insertTime = formatDate(data.insertTime);
                        setNewSubscriptionAPI(data)
                    }
                    setLoading(false);
                })
                .catch((error) => {
                    if (error instanceof InteractionRequiredAuthError) {
                        instance.acquireTokenRedirect(accessTokenRequest);
                    }
                    console.log(error);
                    setLoading(false);
                });
        }
        if (localStorage.getItem('accessToken') != null) {
            let accessToken = localStorage.getItem('accessToken');
            commonOperations(accessToken);
        } else {
            await instance.initialize();
            await instance.acquireTokenSilent(accessTokenRequest).then((accessTokenResponse: any) => {
                let accessToken = accessTokenResponse.accessToken;
                commonOperations(accessToken);
            })
                .catch((error: any) => {
                    if (error instanceof InteractionRequiredAuthError) {
                        instance.acquireTokenRedirect(accessTokenRequest);
                    }
                    console.log(error);
                });
        }

    }

    const handleChangeName = useCallback((event: TextBoxChangeEvent) => {
        setApiName(event.target.value);
        setSubscriptionName(event.target.value);
    }, []);

    const onTypeChange = (event: any) => {
        setTypeSelected(true)
        setTypeName(event.value.name)
        setTypeColor(event.value.color)
    }

    const handleChangeHeaderKey = useCallback((event: TextBoxChangeEvent) => {
        setKeyHeader(event.target.value);
        setFocusHeader(false);
        setFocusParam(false);
        setFocusBody(false);
        setFocusUrl(false);
    }, []);

    const handleChangeHeaderValue = useCallback((event: TextBoxChangeEvent) => {
        setHeaderValue(event.target.value);
    }, []);

    const handleFocusHeaderValue = useCallback(() => {
        setFocusBody(false);
        setFocusUrl(false);
        setFocusParam(false);
        setFocusHeader(true);
    }, []);

    const handleFocusHeaderKey = useCallback(() => {
        setFocusHeader(false);
        setFocusParam(false);
        setFocusBody(false);
        setFocusUrl(false);
    }, []);

    const addNewHeader = (key: any, value: any) => {

        let elementId:any = []
        newHeaderAPI.map((element: any) => {
            elementId.push(element[0].split(': ')[0])
        })
        
        if (elementId.includes(key)) {
            setHeaderMessage(true)
            return;
        }

        setNewHeaderKey([...newHeaderKey, key]);

        if (Object.values(newHeaderKey).includes(key) || key == '') {
            return
        } else {
            let newHeader: any = key + ': ' + value
            setNewHeaderAPI([...newHeaderAPI, newHeader]);
        }
        setKeyValueHeaderList([...keyValueHeaderList, { key: key, value: value }]);
    }

    useEffect(() => {
        if (headerMessage) {
            setTimeout(() => {
                setHeaderMessage(false);
            }, 3000);
        }
    }, [headerMessage]);

    const removeNewHeader = (index: any) => {
        setNewHeaderKey((oldValues: any) => {
            return oldValues.filter((_: any, i: any) => i !== index)
        })
        setNewHeaderAPI((oldValues: any) => {
            return oldValues.filter((_: any, i: any) => i !== index)
        })
    }

    const handleChangeUrl = ((event: TextBoxChangeEvent) => {
        setUrl(event.target.value);
    });

    const handleFocusUrl = useCallback(() => {
        setFocusHeader(false);
        setFocusParam(false);
        setFocusBody(false);
        setFocusUrl(true);
    }, []);

    const handleChangeBody = useCallback((event: any) => {
        setBody(event.target.value);
    }, []);

    const handleFocusBody = useCallback(() => {
        setFocusHeader(false);
        setFocusParam(false);
        setFocusUrl(false);
        setFocusBody(true);
    }, []);

    const onDeviceTypeChange = (event: any) => {
        setDeviceTypeName(event.value)
        setCommandTypeName('')
        setDuration('')
        setFirstReleValue('')
        setSecondReleValue('')
    }

    const onCommandTypeChange = (event: any) => {
        setCommandTypeName(event.value)
    }

    const handleDuration = (e: TextBoxChangeEvent) => {
        setDuration(e.target.value);
        setUnitDurationConverted(millisToMinutesAndSeconds(e.target.value))
    }
    const onFirstReleChange = (event: any) => {
        setFirstReleValue(event.value)
    }

    const onSecondReleChange = (event: any) => {
        setSecondReleValue(event.value)
    }

    const onFirstRedValueChange = (event: any) => {
        setFirstRedValue(event.value)
    }

    const onFirstGreenValueChange = (event: any) => {
        setFirstGreenValue(event.value)
    }

    const onFirstBlueValueChange = (event: any) => {
        setFirstBlueValue(event.value)
    }

    const onFirstBuzzValueChange = (event: any) => {
        setFirstBuzzValue(event.value)
    }

    const onFirstVibrationValueChange = (event: any) => {
        setFirstVibrationValue(event.value)
    }

    const onDurationValueChange = (event: any) => {
        setDurationValueSelected(event.value)
    }

    const handleFirstSequence = (event: CheckboxChangeEvent) => {
        setCheckedFirstSequence(event.value);
    };
    const handleSecondSequence = (event: CheckboxChangeEvent) => {
        setCheckedSecondSequence(event.value);
    };
    const handleThirdSequence = (event: CheckboxChangeEvent) => {
        setCheckedThirdSequence(event.value);
    };
    const handleFourthSequence = (event: CheckboxChangeEvent) => {
        setCheckedFourthSequence(event.value);
    };

    const toggleShowAPIBackchannel = () => {
        setShowAPIBackchannel(!showAPIBackchannel)
        setDeviceTypeName('')
    }

    //const upsert = (array:any, element:any) => {
    //    const i:any = array.findIndex((e:any) => e.id === element.id);
    //    if (i > -1) array[i] = element;
    //    else array.push(element);
    //}

    const handleChangeKeyParam = useCallback((event: TextBoxChangeEvent) => {
        setKeyParam(event.target.value);
        setFocusHeader(false);
    }, []);

    const handleFocusKeyParam = (() => {
        setFocusUrl(false);
        setFocusBody(false);
        setFocusHeader(false);
        setFocusParam(false);
    });

    const handleChangeValueParam = useCallback((event: TextBoxChangeEvent) => {
        setParamValue(event.target.value);
    }, []);

    const handleFocusValueParam = (() => {
        setFocusUrl(false);
        setFocusBody(false);
        setFocusHeader(false);
        setFocusParam(true);
    })

    const addNewParam = (key: any, value: any) => {

        let elementId: any = []
        newParamAPI.map((element: any) => {
            elementId.push(element[0].split(': ')[0])
        })

        if (elementId.includes(key)) {
            setParamMessage(true)
            return;
        }

        if (!paramMessage) {
            setTimeout(() => {
                setParamMessage(false);
            }, 3000);
        }

        setNewParamKey([...newParamKey, key]);

        if (Object.values(newParamKey).includes(key) || key == '') {
            return
        } else {
            let newParam: any = key + ': ' + value
            setNewParamAPI([...newParamAPI, newParam]);
        }
        setKeyValueParamList([...keyValueParamList, { key: key, value: value }]);
    }

    useEffect(() => {
        if (paramMessage) {
            setTimeout(() => {
                setParamMessage(false);
            }, 3000);
        }
    }, [paramMessage]);

    const removeNewParam = (index: any) => {
        setNewParamKey((oldValues: any) => {
            return oldValues.filter((_: any, i: any) => i !== index)
        })
        setNewParamAPI((oldValues: any) => {
            return oldValues.filter((_: any, i: any) => i !== index)
        })
    }

    const saveNewSubscriptionAPI = async () => {

        setLoading(true);

        let paramsList: any = []
        let headerList: any = []

        //if(subscriptionIdSelected != -1){ // updating subscription
        //    //paramsList = keyValueParamList.map((element:any) => {
        //    //    return(`${element.key}:${element.value.toString().replace(/,/g, '')}`)
        //    //}).join(',')
        //    paramsList = newParamAPI.map((element:any) => {
        //        return(`${element?.toString().replace(/,/g, '')}`)
        //    }).join(',')

        //    //headerList = keyValueHeaderList.map((element:any) => {
        //    //    return(`${element.key}:${element.value.toString().replace(/,/g, '')}`)
        //    //}).join(',')
        //    headerList = newHeaderAPI.map((element:any) => {
        //        return(`${element?.toString().replace(/,/g, '')}`)
        //    }).join(',')
        //}
        //else{ // new subscription
        //}      

        paramsList = newParamAPI.map((element: any) => {
            return (element?.toString().replace(/,/g, ''))
        }).join(',')

        headerList = newHeaderAPI.map((element: any) => {
            return (element?.toString().replace(/,/g, ''))
        }).join(',')


        const currentDate:any = formatDate(new Date().toJSON());

        const params = {
            name: apiName,
            parameters: paramsList != '' ? paramsList : "",
            body: body[0] ?? "",
            contentType: "",
            headers: headerList != '' ? headerList : "",
            insertTime: currentDate, // current date
            requestType: typeName,
            url: url != '' ? url : ""
        }

        const commonOperations = (accessToken: any) => {
            const headers = { 'Authorization': `Bearer ${accessToken}`, 'Language': languageId };
            axios.post(`${SERVER_URL}/subscription/api`, params, { headers })
                .then(() => {
                    //const data = res?.data?.data
                    setNewSubscriptionAPI([...newSubscriptionAPI, subscriptionName]);
                    setApiName('');
                    setUrl('');
                    setBody('');
                    setTypeName('');
                    setKeyHeader('');
                    setHeaderValue('');
                    setKeyParam('');
                    setParamValue('');
                    setKeyValueParamList([]);
                    setKeyValueHeaderList([]);
                    setNewParamAPI([]);
                    setNewParamKey([]);
                    setNewHeaderAPI([]);
                    setNewHeaderKey([]);
                    getSubscriptionAPIList();
                    setSaved(true);
                    setLoading(false);
                }).catch((data) => {
                    setError(data?.message);
                    setLoading(false);
                });
        }

        if (localStorage.getItem('accessToken') != null) {
            let accessToken = localStorage.getItem('accessToken');
            commonOperations(accessToken);
        } else {
            await instance.initialize();
            await instance.acquireTokenSilent(accessTokenRequest).then((accessTokenResponse: any) => {
                // Acquire token silent success
                let accessToken = accessTokenResponse.accessToken;
                commonOperations(accessToken);
            })
                .catch((error: any) => {
                    if (error instanceof InteractionRequiredAuthError) {
                        instance.acquireTokenRedirect(accessTokenRequest);
                    }
                    console.log(error);
                });
        }

        if (!nameMessage) {
            setTimeout(() => {
                setNameMessage(false);
            }, 3000);
        }
        if (!saved) {
            setTimeout(() => {
                setSaved(false);
            }, 3000);
        }
    }

    const updateSubscriptionAPI = async () => {

        setLoading(true);

        let paramsList: any = []
        let headerList: any = []

        //paramsList = keyValueParamList.map((element:any) => {
        //    return(`${element.key}:${element.value.toString().replace(/,/g, '')}`)
        //}).join(',')
        paramsList = newParamAPI.map((element: any) => {
            return (`${element?.toString().replace(/,/g, '')}`)
        }).join(',')

        //headerList = keyValueHeaderList.map((element:any) => {
        //    return(`${element.key}:${element.value.toString().replace(/,/g, '')}`)
        //}).join(',')
        headerList = newHeaderAPI.map((element: any) => {
            return (`${element?.toString().replace(/,/g, '')}`)
        }).join(',')


        const params = {
            name: apiName,
            parameters: paramsList != '' ? paramsList : "",
            body: body[0] ?? "",
            contentType: "",
            headers: headerList != '' ? headerList : "",
            insertTime: insertTime, // current date
            requestType: typeName,
            url: url != '' ? url : ""
        }

        const commonOperations = (accessToken: any) => {
            const headers = { 'Authorization': `Bearer ${accessToken}`, 'Language': languageId };
            axios.put(`${SERVER_URL}/subscription/api/${subscriptionIdSelected}`, params, { headers })
                .then(() => {
                    //const data = res?.data?.data
                    setNewSubscriptionAPI([...newSubscriptionAPI, subscriptionName]);
                    setApiName('');
                    setUrl('');
                    setBody('');
                    setTypeName('');
                    setKeyHeader('');
                    setHeaderValue('');
                    setKeyParam('');
                    setParamValue('');
                    setKeyValueParamList([]);
                    setKeyValueHeaderList([]);
                    setNewParamAPI([]);
                    setNewParamKey([]);
                    setNewHeaderAPI([]);
                    setNewHeaderKey([]);
                    getSubscriptionAPIList();
                    setUpdated(true);
                    setLoading(false);
                }).catch((data) => {
                    setError(data?.message);
                    setLoading(false);
                });
        }

        if (localStorage.getItem('accessToken') != null) {
            let accessToken = localStorage.getItem('accessToken');
            commonOperations(accessToken);
        } else {
            await instance.initialize();
            await instance.acquireTokenSilent(accessTokenRequest).then((accessTokenResponse: any) => {
                // Acquire token silent success
                let accessToken = accessTokenResponse.accessToken;
                commonOperations(accessToken);
            })
                .catch((error: any) => {
                    if (error instanceof InteractionRequiredAuthError) {
                        instance.acquireTokenRedirect(accessTokenRequest);
                    }
                    console.log(error);
                });
        }

        if (!nameMessage) {
            setTimeout(() => {
                setNameMessage(false);
            }, 3000);
        }
        if (!updated) {
            setTimeout(() => {
                setUpdated(false);
            }, 3000);
        }
    }

    const removeSubscriptionAPI = async (subscription: any, index: any) => {

        setLoading(true);

        const commonOperations = (accessToken: any) => {
            const headers = { 'Authorization': `Bearer ${accessToken}`, 'Language': languageId };
            axios.delete(`${SERVER_URL}/subscription/api/${subscription.id}`, { headers })
                .then(() => {
                    setNewSubscriptionAPI((oldValues: any) => {
                        return oldValues.filter((_: any, i: any) => i !== index)
                    })
                    setApiName('');
                    setUrl('');
                    setBody('');
                    setTypeName('');
                    setKeyHeader('');
                    setHeaderValue('');
                    setKeyParam('');
                    setParamValue('');
                    setKeyValueParamList([]);
                    setKeyValueHeaderList([]);
                    setNewParamAPI([]);
                    setNewParamKey([]);
                    setNewHeaderAPI([]);
                    setNewHeaderKey([]);
                    setRemoved(true);
                    setLoading(false);
                }).catch((data) => {
                    setError(data?.message);
                    setLoading(false);
                });
        }

        if (localStorage.getItem('accessToken') != null) {
            let accessToken = localStorage.getItem('accessToken');
            commonOperations(accessToken);
        } else {
            await instance.initialize();
            await instance.acquireTokenSilent(accessTokenRequest).then((accessTokenResponse: any) => {
                // Acquire token silent success
                let accessToken = accessTokenResponse.accessToken;
                commonOperations(accessToken);
            })
                .catch((error: any) => {
                    if (error instanceof InteractionRequiredAuthError) {
                        instance.acquireTokenRedirect(accessTokenRequest);
                    }
                    console.log(error);
                });
        }

        if (!removed) {
            setTimeout(() => {
                setRemoved(false);
            }, 3000);
        }
        //if (!error) {
        //    setTimeout(() => {
        //        setError(false);
        //    }, 3000);
        //}
    }

    const copySubscriptionAPI = async(subscription: any) => {
        setLoading(true);
        
        const commonOperations = (accessToken: any) => {
            const headers = { 'Authorization': `Bearer ${accessToken}`, 'Language': languageId };
            
            axios.post(`${SERVER_URL}/subscription/api/${subscription.id}/copy`, null, { headers })
                .then(() => {

                    setSaved(true)    
                    getSubscriptionAPIList();

                    setTimeout(() => {
                        setSaved(false)
                    }, 3000);
                    
                    setLoading(false);
                }).catch((data) => {
                    setError(data?.message);
                    setLoading(false);
                });
        }

        if (localStorage.getItem('accessToken') != null) {
            let accessToken = localStorage.getItem('accessToken');
            commonOperations(accessToken);
        } else {
            await instance.initialize();
            await instance.acquireTokenSilent(accessTokenRequest).then((accessTokenResponse: any) => {
                // Acquire token silent success
                let accessToken = accessTokenResponse.accessToken;
                commonOperations(accessToken);
            })
                .catch((error: any) => {
                    if (error instanceof InteractionRequiredAuthError) {
                        instance.acquireTokenRedirect(accessTokenRequest);
                    }
                    console.log(error);
                });
        }
    }

    const itemRenderTypeList = (li: any, itemProps: any) => {
        const name = itemProps.dataItem.name;
        const color = itemProps.dataItem.color;
        const itemChildren = (
            <span style={{ color: `${color}`, fontWeight: 'bold' }}>
                {name}
            </span>
        );
        return cloneElement(li, li.props, itemChildren);
    };

    const millisToMinutesAndSeconds = (milliseconds: any) => {

        var hours, minutes, seconds, total_hours, total_minutes, total_seconds;
        total_seconds = Math.floor(milliseconds / 1000);
        total_minutes = Math.floor(total_seconds / 60);
        total_hours = Math.floor(total_minutes / 60);

        seconds = total_seconds % 60;
        minutes = total_minutes % 60;
        hours = total_hours % 24;

        hours == 0 && minutes == 0 && seconds == 0 ? setUnitDuration('ms') : hours == 0 && minutes == 0 ? setUnitDuration('s') : hours == 0 ? setUnitDuration('m') : setUnitDuration('h');

        if (hours == 0 && minutes == 0 && seconds == 0) {
            return milliseconds;
        }
        else if (hours == 0 && minutes == 0) {
            return seconds;
        }
        else if (hours == 0) {
            return minutes + ":" + (seconds < 10 ? '00' : '') + seconds;
        }
        else {
            return hours + ':' + minutes + ':' + seconds;
        }
    }

    const handleMetadataHeaderSelected = (e: any) => {
        //let metadataSelectedList:any = [...metadataHeaderSelected];
        let metadataSelectedList: any = [];
        metadataSelectedList.push({ meta: e.dataItem.name });
        setMetadataHeaderSelected(metadataSelectedList);
        let metaList: any = metadataSelectedList.map((meta: any) => { return meta.meta }).join("")

        if (headerValue != '') {
            setHeaderValue([headerValue, metaList])
        } else {
            setHeaderValue(metaList)
        }
    }
    const handleMetadataParamSelected = (e: any) => {
        //let metadataSelectedList:any = [...metadataParamSelected];
        let metadataSelectedList: any = [];
        metadataSelectedList.push({ meta: e.dataItem.name });
        setMetadataParamSelected(metadataSelectedList);
        let metaList: any = metadataSelectedList.map((meta: any) => { return meta.meta })

        if (paramValue != '') {
            setParamValue([paramValue, metaList])
        } else {
            setParamValue(metaList)
        }
    }
    const handleMetadataUrlSelected = (e: any) => {
        //let metadataSelectedList:any = [...metadataUrlSelected];
        let metadataSelectedList: any = [];
        metadataSelectedList.push({ meta: e.dataItem.name });
        setMetadataUrlSelected(metadataSelectedList);
        let metaList: any = metadataSelectedList.map((meta: any) => { return meta.meta })

        if (url != '') {
            setUrl([url, metaList])
        } else {
            setUrl(metaList)
        }
    }

    const handleMetadataBodySelected = (e: any) => {
        //let metadataSelectedList:any = [...metadataBodySelected];
        let metadataSelectedList: any = [];
        metadataSelectedList.push({ meta: e.dataItem.name });
        setMetadataBodySelected(metadataSelectedList);
        let metaList: any = metadataSelectedList.map((meta: any) => { return meta.meta })

        if (body != '') {
            setBody([body, metaList])
        } else {
            setBody(metaList)
        }
    }

    const itemRefs:any = useRef([]);

    
    const loadSubscriptionSelected = (subscription: any) => {

        setNewParamAPI([]);
        setNewHeaderAPI([]);


        let subscriptionId: any = subscription.id;
        setSubscriptionIdSelected(subscriptionId);

        setApiName(subscription.name);
        setUrl(subscription.url);
        setTypeName(subscription.requestType);
        setInsertTime(subscription.insertTime);

        if (subscription?.parameters) {
            let loadedParams: any = subscription?.parameters?.split(',')
            let splittedParams: any = []
            loadedParams.forEach((item: any) => {
                splittedParams.push([item])
            });
            splittedParams != '' ? setNewParamAPI(splittedParams) : null
        }

        if (subscription?.headers) {
            let loadedHeaders: any = subscription?.headers?.split(',')
            let splittedHeaders: any = []
            loadedHeaders.forEach((item: any) => {
                splittedHeaders.push([item])
            });
            splittedHeaders != '' ? setNewHeaderAPI(splittedHeaders) : null
        }

        setBody(subscription.body);

        // Access the clicked element's ref
        itemRefs?.current?.forEach((element:any, i:any) => {
            if (i == subscription.id) {
              itemRefs.current[i].style.background = '#198792' ;   
              itemRefs.current[i].style.borderRadius = '10px' ;   
              itemRefs.current[i].style.color = '#ffffff' ;   
            }else{
                itemRefs?.current[i]?.style?.removeProperty('background')
                itemRefs?.current[i]?.style?.removeProperty('color')
            }
        });

    };

    return (
        <div className="flex-parent-element">
            {loading && loadingPanel}
            <br />
            <NotificationGroup
                style={{
                    right: 0,
                    bottom: 50,
                    alignItems: "flex-start",
                    flexWrap: "wrap-reverse",
                }}
            >
                <Fade enter={true} exit={true}>
                    {nameMessage && (
                        <Notification
                            type={{ style: "warning", icon: true }}
                            closable={true}
                            onClose={() => setNameMessage(false)}
                        >
                            <span>{localizationService.toLanguageString('configuration.rules.subscription_api_name_message', 'NOT FOUND')}</span>
                        </Notification>
                    )}
                    {/*{commandMessage && (
                        <Notification
                            type={{ style: "warning", icon: true }}
                            closable={true}
                            onClose={() => setCommandMessage(false)}
                        >
                            <span>{localizationService.toLanguageString('configuration.rules.subscription_command_type_message', 'NOT FOUND')}</span>
                        </Notification>
                    )}
                    {actuatorMessage && (
                        <Notification
                            type={{ style: "warning", icon: true }}
                            closable={true}
                            onClose={() => setActuatorMessage(false)}
                        >
                            <span>{localizationService.toLanguageString('configuration.rules.subscription_actuator_message', 'NOT FOUND')}</span>
                        </Notification>
                    )}*/}
                    {removed && (
                        <Notification
                            type={{ style: "success", icon: true }}
                            closable={true}
                            onClose={() => setRemoved(false)}
                        >
                            <span>{localizationService.toLanguageString('configuration.rules.subscription_api_removed', 'NOT FOUND')}</span>
                        </Notification>
                    )}
                    {updated && (
                        <Notification
                            type={{ style: "success", icon: true }}
                            closable={true}
                            onClose={() => setUpdated(false)}
                        >
                            <span>{localizationService.toLanguageString('configuration.rules.subscription_api_updated', 'NOT FOUND')}</span>
                        </Notification>
                    )}
                    {saved && (
                        <Notification
                            type={{ style: "success", icon: true }}
                            closable={true}
                            onClose={() => setSaved(false)}
                        >
                            <span>{localizationService.toLanguageString('configuration.rules.subscription_api_saved', 'NOT FOUND')}</span>
                        </Notification>
                    )}
                    {headerMessage && (
                        <Notification
                            type={{ style: "warning", icon: true }}
                            closable={true}
                            onClose={() => setHeaderMessage(false)}
                        >
                            <span>{localizationService.toLanguageString('configuration.rules.subscription_api_header_message', 'NOT FOUND')}</span>
                        </Notification>
                    )}
                    {paramMessage && (
                        <Notification
                            type={{ style: "warning", icon: true }}
                            closable={true}
                            onClose={() => setParamMessage(false)}
                        >
                            <span>{localizationService.toLanguageString('configuration.rules.subscription_api_param_message', 'NOT FOUND')}</span>
                        </Notification>
                    )}
                </Fade>
            </NotificationGroup>

            {/*subscription api panel list*/}
            <div style={{
                    padding: '20px', 
                    background: "#F7F7F7",
                    flex: '1 1 0px',
                    overflowY: 'auto',     
                }}>
                <div style={{ textAlign:'center', marginBottom:'20px' }}>
                    
                    <p style={{ display:'inline-flex', textAlign: 'center', fontSize: '20px', color: '#1A8893' }}>{localizationService.toLanguageString('configuration.rules.subscription_api', 'NOT FOUND')} ({newSubscriptionAPI.length})</p>
                    
                    <Button
                        title={localizationService.toLanguageString('configuration.rules.subscription_api_save', 'NOT FOUND')}
                        themeColor={"primary"}
                        className="plusParam"
                        style={{
                            marginRight: '10px',
                            marginTop: '0px',
                        }}
                        //disabled={apiName == '' || typeName.length == 0 ? true : false}
                        onClick={() => {
                            let resetSubscription = -1
                            setSubscriptionIdSelected(resetSubscription);
                            setApiName('');
                            setTypeName('');
                            setTypeName('');
                            setUrl('');
                            setKeyHeader('');
                            setHeaderValue('');
                            setKeyParam('');
                            setParamValue('');
                            //saveNewSubscriptionAPI();
                        }}
                    >
                        <Avatar
                            className="plusParam"
                        >
                            <SvgIcon
                                icon={plusIcon}
                                style={{ margin: '8px' }}
                            />
                        </Avatar>
                    </Button>
                </div>
                    
                <div>
                    {newSubscriptionAPI?.map((subscription: any, index: any) => {
                        return (
                            <div
                                key={index}
                            >
                                <div
                                    className="trash-icon"
                                    style={{
                                        float: 'left',
                                        cursor: 'pointer',
                                        alignContent: 'center',
                                        marginRight: '10px'
                                    }}
                                    title={localizationService.toLanguageString('configuration.rules.subscription_api_remove', 'NOT FOUND')}
                                    onClick={() => removeSubscriptionAPI(subscription, index)} >
                                    <Avatar
                                        className="trash-icon"
                                    >
                                        <SvgIcon icon={trashIcon} style={{ verticalAlign: 'baseline', margin: '10px' }} />
                                    </Avatar>
                                </div>

                                    {/*<Button
                                        title={localizationService.toLanguageString('configuration.rules.subscription_api_clone', 'NOT FOUND')}
                                        //themeColor={"primary"}
                                        className="plusParam"
                                        style={{
                                            float: 'left',
                                            cursor: 'pointer',
                                            alignContent: 'center',
                                            marginRight: '10px'
                                        }}
                                        //disabled={apiName == '' || typeName.length == 0 ? true : false}
                                        onClick={() => {
                                            let resetSubscription = -1
                                            setSubscriptionIdSelected(resetSubscription);
                                            setApiName('');
                                            setTypeName('');
                                            setTypeName('');
                                            setUrl('');
                                            setKeyHeader('');
                                            setHeaderValue('');
                                            setKeyParam('');
                                            setParamValue('');
                                            saveNewSubscriptionAPI();
                                        }}
                                    >
                                        <Avatar
                                            className="plusParam"
                                        >
                                            <SvgIcon
                                                icon={copyIcon}
                                                style={{ margin: '8px' }}
                                            />
                                        </Avatar>
                                    </Button>*/}

                                    <div
                                        className="trash-icon"
                                        style={{
                                            float: 'left',
                                            cursor: 'pointer',
                                            alignContent: 'center',
                                            marginRight: '10px'
                                        }}
                                        onClick={() => copySubscriptionAPI(subscription)}                                        
                                        title={localizationService.toLanguageString('configuration.rules.subscription_api_clone', 'NOT FOUND')}
                                    >
                                        <Avatar 
                                            className="trash-icon"
                                        >
                                            <SvgIcon 
                                                icon={copyIcon} 
                                                style={{ verticalAlign: 'baseline', margin: '10px' }} 
                                            />
                                        </Avatar>
                                    </div>  
                                    
                                
                                <p
                                    className="card-block-registry-group"
                                    ref={(el) => (itemRefs.current[subscription.id] = el)}
                                    style={{
                                        cursor: 'pointer',
                                        marginLeft: '10px',
                                        marginBottom: '0px',
                                        padding: '10px'
                                    }}
                                    onClick={() => loadSubscriptionSelected(subscription)}
                                >
                                    {subscription.name}
                                </p>

                            </div>
                        )
                    })}
                </div>
            </div>

            {/*center panel*/}
            <div
                className="flex-right-child-element"
                style={{ 
                    flex: '1 1 170px'
                }}
            >
                {/*name*/}
                <p style={{ fontSize: '16px', color: '#1A8893' }}>{localizationService.toLanguageString('configuration.rules.subscription_api_name', 'NOT_FOUND')}</p>
                <TextBox
                    style={{ width: "350px" }}
                    value={apiName != '' ? apiName : ''}
                    onChange={handleChangeName}
                    onFocus={() => {
                        setFocusBody(false);
                        setFocusUrl(false);
                        setFocusHeader(false);
                        setFocusParam(false);
                    }}
                    placeholder=''
                />

                {/*save*/}
                {
                    subscriptionIdSelected == '-1' ?
                        <Button
                            title={localizationService.toLanguageString('configuration.rules.subscription_save', 'NOT FOUND')}
                            themeColor={"primary"}
                            className="saveParam"
                            disabled={apiName == '' || typeName.length == 0 ? true : false}
                            onClick={saveNewSubscriptionAPI}
                        >
                            <Avatar
                                className="saveParam"
                            >
                                <SvgIcon
                                    icon={saveIcon}
                                    style={{ margin: '8px' }}
                                />
                            </Avatar>
                        </Button>
                        :
                        <div style={{ display: 'inline' }}>
                            <Button
                                title={localizationService.toLanguageString('configuration.rules.subscription_api_update', 'NOT FOUND')}
                                themeColor={"primary"}
                                className="saveParam"
                                style={{
                                    marginRight: '10px'
                                }}
                                disabled={apiName == '' || typeName.length == 0 ? true : false}
                                onClick={updateSubscriptionAPI}
                            >
                                <Avatar
                                    className="saveParam"
                                >
                                    <SvgIcon
                                        icon={saveIcon}
                                        style={{ margin: '8px' }}
                                    />
                                </Avatar>
                            </Button>
                        </div>
                }

                <br />
                <br />
                <br />

                {/*type*/}
                <div style={{ color: '#1A8893' }}>{localizationService.toLanguageString('configuration.rules.subscription_api_type', 'NOT FOUND')}</div>
                <DropDownList
                    style={{
                        width: "350px",
                    }}
                    data={typeData?.data?.map((type: any) => {
                        return (type)
                    })}
                    itemRender={itemRenderTypeList}
                    value={<span style={{ fontWeight: 'bold', color: `${typeColor}` }}>
                        {typeName}
                    </span>}
                    onChange={onTypeChange}
                />

                <br />
                <br />
                <br />

                {/*header*/}
                <p style={{ color: '#1A8893' }}>{localizationService.toLanguageString('configuration.rules.subscription_api_header', 'NOT_FOUND')}</p>

                {/*add header*/}
                <div style={{ display: 'inline-flex' }}>

                    {/*key*/}
                    <div>
                        <p style={{ fontSize: '12px', margin: '10px' }}>{localizationService.toLanguageString('configuration.rules.subscription_api_key', 'NOT_FOUND')}</p>
                        <TextBox
                            style={{ width: "130px", marginRight: '20px' }}
                            value={keyHeader != '' ? keyHeader : ''}
                            onChange={handleChangeHeaderKey}
                            onFocus={handleFocusHeaderKey}
                        //placeholder='0'
                        />
                        <br />
                    </div>

                    {/*value*/}
                    <div>
                        <p style={{ fontSize: '12px', margin: '10px' }}>{localizationService.toLanguageString('configuration.rules.subscription_api_value', 'NOT_FOUND')}</p>
                        <TextBox
                            style={{ width: "200px" }}
                            //value={headerValue != '' ? headerValue : '' + (metadataHeaderSelected.map((meta: any) => { return meta.meta }) ?? '')}
                            value={headerValue}
                            onChange={handleChangeHeaderValue}
                            onFocus={handleFocusHeaderValue}
                        //placeholder='0'
                        />
                    </div>

                    <Button
                        title={localizationService.toLanguageString('configuration.rules.subscription_api_add_header', 'NOT FOUND')}
                        themeColor={"primary"}
                        className="plusParam"
                        disabled={keyHeader == '' || headerValue == ''}
                        onClick={() => addNewHeader(keyHeader, headerValue)}
                    >
                        <Avatar
                            className="plusParam"
                        >
                            <SvgIcon
                                icon={plusIcon}
                                style={{ margin: '8px' }}
                            />
                        </Avatar>
                    </Button>

                </div>

                <br />

                {/*delete button*/}
                <div className="k-listview-item row p-1 align-middle" style={{ marginTop: '10px', marginLeft: '0px' }}>
                    {newHeaderAPI?.map((headerAPI: any, index: any) => {
                        return (
                            <div key={index} style={{ display: 'inline-flex' }}>
                                <div
                                    className="trash-icon"
                                    style={{
                                        float: 'left',
                                        cursor: 'pointer',
                                        marginRight: '20px'
                                    }}
                                    onClick={() => removeNewHeader(index)} >
                                    <Avatar
                                        className="trash-icon"
                                    >
                                        <SvgIcon
                                            icon={trashIcon}
                                            style={{ verticalAlign: 'baseline', margin: '10px' }}
                                        />
                                    </Avatar>
                                </div>
                                <div style={{ margin: '5px auto' }}>
                                    <p>{headerAPI?.headers ?? headerAPI}</p>
                                </div>
                            </div>
                        )
                    })}
                </div>

                <br />

                {/*url*/}
                <p style={{ fontSize: '12px', margin: '10px' }}>{localizationService.toLanguageString('configuration.rules.subscription_api_url', 'NOT_FOUND')}</p>
                <TextBox
                    style={{ width: "350px", marginRight: '20px' }}
                    value={url}
                    onChange={handleChangeUrl}
                    onFocus={handleFocusUrl}
                //placeholder='url'
                />
                <br />

                {/*body*/}
                <p style={{ fontSize: '12px', margin: '10px' }}>{localizationService.toLanguageString('configuration.rules.subscription_api_body', 'NOT_FOUND')}</p>

                <TextArea
                    size={'small'}
                    fillMode={'solid'}
                    rounded={'medium'}
                    style={{ width: '350px' }}
                    value={body}
                    onChange={handleChangeBody}
                    onFocus={handleFocusBody}
                />

                {/*showAPIBackchannel*/}
                <div
                    title={localizationService.toLanguageString('configuration.rules.subscription_api_backchannel', 'NOT FOUND')}
                    className="backchannel"
                    style={{
                        display: 'inline',
                        marginLeft: '10px',
                        cursor: 'pointer'
                    }}
                    onClick={toggleShowAPIBackchannel}
                >
                    <Avatar
                        className="backchannel"
                    >
                        <SvgIcon
                            icon={rssIcon}
                            className="backchannel"
                            style={{ verticalAlign: 'baseline', margin: '10px' }}
                        />
                    </Avatar>
                </div>

                <br />
                <br />
                <br />


                {/*parameters*/}
                <p style={{ color: '#1A8893' }}>{localizationService.toLanguageString('configuration.rules.subscription_api_parameters', 'NOT_FOUND')}</p>

                <div style={{ display: 'inline-flex' }}>

                    {/*key*/}
                    <div>
                        <p style={{ fontSize: '12px', margin: '10px' }}>{localizationService.toLanguageString('configuration.rules.subscription_api_key_param', 'NOT_FOUND')}</p>
                        <TextBox
                            style={{ width: "130px", marginRight: '20px' }}
                            value={keyParam != '' ? keyParam : ''}
                            onChange={handleChangeKeyParam}
                            onFocus={handleFocusKeyParam}
                        //placeholder='0'
                        />
                        <br />
                    </div>

                    {/*value*/}
                    <div>
                        <p style={{ fontSize: '12px', margin: '10px' }}>{localizationService.toLanguageString('configuration.rules.subscription_api_value_param', 'NOT_FOUND')}</p>
                        <TextBox
                            style={{ width: "200px" }}
                            value={paramValue}
                            onChange={handleChangeValueParam}
                            onFocus={handleFocusValueParam}
                        //placeholder='0'
                        />
                    </div>

                    {/*addNewParam*/}
                    <Button
                        title={localizationService.toLanguageString('configuration.rules.subscription_api_add_parameter', 'NOT FOUND')}
                        themeColor={"primary"}
                        className="plusParam"
                        disabled={keyParam == '' || paramValue == ''}
                        onClick={() => addNewParam(keyParam, paramValue)}
                    >
                        <Avatar
                            className="plusParam"
                        >
                            <SvgIcon
                                icon={plusIcon}
                                style={{
                                    margin: '8px'
                                }}
                            />
                        </Avatar>
                    </Button>

                </div>

                <br />

                <div className="k-listview-item row p-1 align-middle" style={{ marginTop: '10px', marginBottom: '40px', marginLeft: '0px' }}>
                    {newParamAPI?.map((paramAPI: any, index: any) => {
                        return (
                            <div key={index} style={{ display: 'inline' }}>
                                <div
                                    className="trash-icon"
                                    style={{
                                        float: 'left',
                                        cursor: 'pointer',
                                        marginRight: '20px'
                                    }}
                                    onClick={() => removeNewParam(index)}
                                >
                                    <Avatar
                                        className="trash-icon"
                                    >
                                        <SvgIcon icon={trashIcon} style={{ verticalAlign: 'baseline', margin: '10px' }} />
                                    </Avatar>
                                </div>
                                <div style={{ margin: '5px auto' }}>
                                    <p>{paramAPI ?? paramAPI}</p>
                                </div>
                            </div>
                        )
                    })}
                </div>

            </div>

            {/*metadata panel*/}
            <div 
                className="flex-center-child-element" 
                style={{ 
                    background: "#F7F7F7",
                    flex: '1 1 0px'
                 }}
            >
                <h6 style={{ color: 'rgb(26, 136, 147)' }}>{localizationService.toLanguageString('configuration.rules.subscription_api_metadata', 'NOT_FOUND')}</h6>
                <ListBox
                    style={{ height: '99%', width: "95%", pointerEvents: `${focusHeader || focusParam || focusBody || focusUrl ? 'fill' : 'none'}`, opacity: `${focusHeader || focusParam || focusBody || focusUrl ? '1' : '0.5'}` }}
                    data={metadataList?.data?.map((metadata: any) => {
                        return metadata
                    })}
                    textField="name"
                    onItemClick={(e: any) => {
                        if (focusHeader) {
                            handleMetadataHeaderSelected(e)
                        }
                        else if (focusParam) {
                            handleMetadataParamSelected(e)
                        }
                        else if (focusUrl) {
                            handleMetadataUrlSelected(e)
                        }
                        else if (focusBody) {
                            handleMetadataBodySelected(e)
                        }
                    }}
                />
            </div>            

            {
                showAPIBackchannel &&
                <Window
                    title={localizationService.toLanguageString('configuration.rules.subscription_backchannel_help', 'NOT_FOUND')}
                    onClose={() => {
                        toggleShowAPIBackchannel()
                        setCommandTypeName('')
                    }}
                    resizable={false}
                    initialWidth={760}
                    initialHeight={680}
                >
                    {/*<form className="k-form">*/}
                    {/*<legend>{localizationService.toLanguageString('configuration.rules.subscription_backchannel_help', 'NOT_FOUND')}</legend>*/}

                    <div style={{ textAlign: 'left' }}>{localizationService.toLanguageString('configuration.rules.subscription_backchannel_device_type', 'NOT_FOUND')}</div>
                    <DropDownList
                        data={deviceType.data?.map((device: any) => {
                            return (
                                device.name
                            )
                        })}
                        style={{ width: '50%', float: 'left' }}
                        onChange={onDeviceTypeChange}
                    />

                    <br />
                    <br />

                    {
                        deviceTypeName == 'Veicolo' &&
                        <div style={{ overflowX: 'auto' }}>
                            <div style={{ display: 'grid' }}>
                                <div style={{ textAlign: 'left' }}>{localizationService.toLanguageString('configuration.rules.subscription_backchannel_duration', 'NOT_FOUND')}</div>
                                <TextBox
                                    placeholder={localizationService.toLanguageString('configuration.rules.subscription_backchannel_duration', 'NOT_FOUND')}
                                    type={'number'}
                                    min={0}
                                    width={50}
                                    max={9999999}
                                    style={{ width: '50%', float: 'left' }}
                                    value={duration != '' ? duration : ''}
                                    onChange={handleDuration}
                                />
                                <p style={{ width: '80px', marginLeft: '20px' }}>{unitDurationConverted} {unitDuration}</p>

                                <br />

                                <div style={{ textAlign: 'left' }}>{localizationService.toLanguageString('configuration.rules.subscription_backchannel_first_rele', 'NOT_FOUND')}</div>
                                <DropDownList
                                    data={firstRele.data.map((value: any) => {
                                        return (
                                            value.name
                                        )
                                    })}
                                    style={{ width: '50%', float: 'left' }}
                                    value={firstReleValue ?? ''}
                                    onChange={onFirstReleChange}
                                />

                                <br />

                                <div style={{ textAlign: 'left' }}>{localizationService.toLanguageString('configuration.rules.subscription_backchannel_second_rele', 'NOT_FOUND')}</div>
                                <DropDownList
                                    data={secondRele.data.map((value: any) => {
                                        return (
                                            value.name
                                        )
                                    })}
                                    style={{ width: '50%', float: 'left' }}
                                    value={secondReleValue ?? ''}
                                    onChange={onSecondReleChange}
                                />
                            </div>

                        </div>
                    }

                    {
                        deviceTypeName == 'Persona' &&
                        <div>
                            <div style={{ textAlign: 'left' }}>{localizationService.toLanguageString('configuration.rules.subscription_backchannel_command_type', 'NOT_FOUND')}</div>
                            <DropDownList
                                //defaultItem={''}
                                data={commandType.data?.map((command: any) => {
                                    return (
                                        command.name
                                    )
                                })}
                                style={{ width: '50%', float: 'left' }}
                                onChange={onCommandTypeChange}
                            />
                            <br />
                            <br />
                        </div>
                    }
                    {commandTypeName == 'Configura' &&
                        <div style={{ overflowX: 'auto' }}>
                            <div style={{ display: 'grid' }}>
                                <div style={{ textAlign: 'left' }}>{localizationService.toLanguageString('configuration.rules.subscription_backchannel_duration', 'NOT_FOUND')}</div>
                                <div style={{ display: 'inline-flex', alignItems: 'baseline' }}>
                                    <TextBox
                                        type={'number'}
                                        min={0}
                                        width={50}
                                        max={9999999}
                                        value={duration ?? ''}
                                        style={{ width: '50%', float: 'left' }}
                                        onChange={handleDuration}
                                        placeholder={localizationService.toLanguageString('configuration.rules.subscription_backchannel_duration', 'NOT_FOUND')}
                                    />
                                    <p style={{ width: '80px', marginLeft: '20px' }}>{unitDurationConverted} {unitDuration}</p>
                                </div>
                            </div>

                            <br />

                            <div style={{ textAlign: 'left', marginTop: '20px' }}>{localizationService.toLanguageString('configuration.rules.subscription_backchannel_sequences', 'NOT_FOUND')}</div>

                            {/*first sequence*/}
                            <FirstSequence />

                            {/*<div style={{ display: 'inline-flex'}}>

                            <div style={{ color: '#1A8995', textAlign: 'left', margin:'25px 0px 0px 0px' }}>{localizationService.toLanguageString('configuration.rules.subscription_backchannel_enabled', 'NOT_FOUND')}</div>
                                <Checkbox
                                    //label={localizationService.toLanguageString('configuration.rules.subscription_backchannel_enabled', 'NOT_FOUND')}
                                    checked={checkedFirstSequence}
                                    style={{ marginTop: '30px', marginRight: '20px', marginLeft: '10px' }}
                                    onChange={handleFirstSequence}
                                />

                                <div  style={{ display: 'inline', marginRight: '10px', marginLeft: '10px', width: '85px' }}>
                                    <div style={{ textAlign: 'left' }}>{localizationService.toLanguageString('configuration.rules.subscription_backchannel_red', 'NOT_FOUND')}</div>
                                    <DropDownList
                                        data={redValues.data?.map((value: any) => {
                                            return (
                                                value.name
                                            )
                                        })}
                                        onChange={onFirstRedValueChange}
                                    />
                                </div>
                                <div  style={{ display: 'inline', marginRight: '10px', width: '85px' }}>
                                    <div style={{ textAlign: 'left' }}>{localizationService.toLanguageString('configuration.rules.subscription_backchannel_green', 'NOT_FOUND')}</div>
                                    <DropDownList
                                        data={redValues.data?.map((value: any) => {
                                            return (
                                                value.name
                                            )
                                        })}
                                        onChange={onFirstRedValueChange}
                                    />
                                </div>
                                <div  style={{ display: 'inline', marginRight: '10px', width: '85px' }}>
                                    <div style={{ textAlign: 'left' }}>{localizationService.toLanguageString('configuration.rules.subscription_backchannel_blue', 'NOT_FOUND')}</div>
                                    <DropDownList
                                        data={redValues.data?.map((value: any) => {
                                            return (
                                                value.name
                                            )
                                        })}
                                        onChange={onFirstRedValueChange}
                                    />
                                </div>
                                <div  style={{ display: 'inline', marginRight: '10px', width: '85px' }}>
                                    <div style={{ textAlign: 'left' }}>{localizationService.toLanguageString('configuration.rules.subscription_backchannel_buzzer', 'NOT_FOUND')}</div>
                                    <DropDownList
                                        data={redValues.data?.map((value: any) => {
                                            return (
                                                value.name
                                            )
                                        })}
                                        onChange={onFirstRedValueChange}
                                    />
                                </div>
                                <div  style={{ display: 'inline', marginRight: '10px', width: '85px' }}>
                                    <div style={{ textAlign: 'left' }}>{localizationService.toLanguageString('configuration.rules.subscription_backchannel_vibration', 'NOT_FOUND')}</div>
                                    <DropDownList
                                        data={redValues.data?.map((value: any) => {
                                            return (
                                                value.name
                                            )
                                        })}
                                        onChange={onFirstRedValueChange}
                                    />
                                </div>
                                <div  style={{ display: 'inline', marginRight: '10px', width: '110px' }}>
                                    <div style={{ textAlign: 'left' }}>{localizationService.toLanguageString('configuration.rules.subscription_backchannel_duration', 'NOT_FOUND')}</div>
                                    <DropDownList
                                        data={durationValue.data?.map((value: any) => {
                                            return (
                                                value.name
                                            )
                                        })}
                                        onChange={onFirstRedValueChange}
                                    />
                                </div>
                            </div>*/}


                            {/*second sequence*/}
                            <SecondSequence />

                            {/*<div style={{ display: 'inline-flex' }}>
                                <Checkbox
                                    label={localizationService.toLanguageString('configuration.rules.subscription_backchannel_enabled', 'NOT_FOUND')}
                                    checked={checkedSecondSequence}
                                    onChange={handleSecondSequence}
                                />
                            </div>*/}

                            {/*third sequence*/}
                            <ThirdSequence />

                            {/*<div style={{ display: 'inline-flex' }}>
                                <Checkbox
                                    label={localizationService.toLanguageString('configuration.rules.subscription_backchannel_enabled', 'NOT_FOUND')}
                                    checked={checkedThirdSequence}
                                    onChange={handleThirdSequence}
                                />
                            </div>*/}

                            {/*fourth sequence*/}
                            <FourthSequence />

                            {/*<div style={{ display: 'inline-flex' }}>
                                <Checkbox
                                    label={localizationService.toLanguageString('configuration.rules.subscription_backchannel_enabled', 'NOT_FOUND')}
                                    checked={checkedFourthSequence}
                                    onChange={handleFourthSequence}
                                />
                            </div>*/}

                            <br />
                            <br />

                        </div>
                    }
                    <div style={{ position: 'absolute', bottom: '10px', right: '0px', }}>
                        <Button
                            type="button"
                            themeColor={"primary"}
                            style={{
                                marginRight: '10px',

                            }}
                            onClick={() => {
                                toggleShowAPIBackchannel()
                                setCommandTypeName('')
                            }}
                        >
                            {localizationService.toLanguageString('configuration.rules.subscription_api_cancel', 'NOT FOUND')}
                            <SvgIcon
                                icon={xIcon}
                                style={{ color: 'white', marginLeft: '8px' }}
                            />
                        </Button>

                        <Button
                            type="button"
                            title={localizationService.toLanguageString('configuration.rules.subscription_save', 'NOT FOUND')}
                            themeColor={"primary"}
                            style={{
                                zIndex: '1',
                                marginRight: '10px',
                            }}
                            onClick={() => {
                                toggleShowAPIBackchannel()
                                setCommandTypeName('')
                                //saveBackchannel
                            }}
                        >
                            {localizationService.toLanguageString('configuration.rules.subscription_save', 'NOT FOUND')}
                            <SvgIcon
                                icon={saveIcon}
                                style={{ color: 'white', marginLeft: '8px' }}
                            />
                        </Button>
                    </div>


                    {/*<div style={{ position: 'absolute', bottom: '0', width: '95%' }}>*/}

                    {/*</form>*/}
                </Window>
            }
        </div>
    )
}